module.exports = __webpack_public_path__ + "static/media/7.526dce01.jpg";